import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
import { TranslateContext, LanguageContext } from './translator';
export default function Translate(_ref) {
  var value = _ref.children;
  var language = useContext(LanguageContext);
  var handleTranslate = useContext(TranslateContext);
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    translation = _useState2[0],
    setTranslation = _useState2[1];
  React.useEffect(function () {
    handleTranslate(value, setTranslation);
  }, [value, language]);
  return translation;
}